module.exports = __webpack_public_path__ + "media/student_v2/assets/images/astronaute-8879a96a9b0a05feb2da0cc87f193f29.svg";